import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { PaymentServiceWithVersionsResponseType } from '../../../../api/types/payments/payment-template';
import { PaymentServicesTable } from '../../../payments/tabs/componenets/payment-services-table';
import globalPaymentServices from '../../../../stores/global-payment-services';

interface SelectPaymentServicesFilterDialogProps {
  visible: boolean;
  onHide: () => void;
  /** Currently applied payment-service ids from the parent filter */
  selectedIds: number[];
  onConfirm: (selectedIds: number[]) => void;
}

export const SelectPaymentServicesFilterDialog: React.FC<
  SelectPaymentServicesFilterDialogProps
> = ({ visible, onHide, selectedIds, onConfirm }) => {
  const [selectedServices, setSelectedServices] = useState<
    PaymentServiceWithVersionsResponseType[]
  >([]);

  // Remount the shared PaymentServicesTable so filter / pagination reset on open.
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    if (!visible) return;

    const idSet = new Set(selectedIds);
    const fromStore = globalPaymentServices.services.filter((s) =>
      idSet.has(s.id),
    );
    setSelectedServices(fromStore);
    setTableKey((k) => k + 1);
  }, [visible, selectedIds]);

  const handleApprove = () => {
    onConfirm(selectedServices.map((s) => s.id));
    onHide();
  };

  return (
    <Dialog
      header="בחירת שירותי תשלום"
      visible={visible}
      onHide={onHide}
      style={{ width: '900px', maxWidth: '95vw', direction: 'rtl' }}
      modal
    >
      <PaymentServicesTable
        key={tableKey}
        selectionMode="multiple"
        selectedServices={selectedServices}
        onSelectionChange={setSelectedServices}
      />

      {selectedServices.length > 0 ? (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            marginTop: '12px',
          }}
        >
          {selectedServices.map((service) => (
            <Chip
              key={service.id}
              label={service.paymentServiceName}
              removable
              onRemove={() => {
                setSelectedServices((prev) =>
                  prev.filter((s) => s.id !== service.id),
                );
              }}
            />
          ))}
        </div>
      ) : null}

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginTop: '20px',
          paddingBottom: '10px',
          gap: '0.5rem',
        }}
      >
        <Button label="ביטול" onClick={onHide} severity="secondary" text />
        <Button label="אישור" onClick={handleApprove} />
      </div>
    </Dialog>
  );
};
